import type { ItemRender } from "antd/es/upload/interface";
import { Loader2, X } from "lucide-react";

/**
 * Replaces the default list row (space-between name vs actions) with an inline
 * [filename] [remove] group and red-on-hover remove, matching other delete affordances in HRMS.
 */
export const separationDocumentUploadItemRender: ItemRender = (
  _origin,
  file,
  _fileList,
  { remove },
) => {
  const isUploading = file.status === "uploading";
  return (
    <div className="inline-flex max-w-full min-w-0 items-center gap-1.5 py-0.5 text-left">
      {isUploading ? (
        <Loader2
          className="h-3.5 w-3.5 shrink-0 animate-spin text-slate-400"
          aria-hidden
        />
      ) : null}
      <span
        className="min-w-0 max-w-full truncate text-sm text-slate-800"
        title={file.name}
      >
        {file.name}
      </span>
      <button
        type="button"
        onClick={remove}
        className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-slate-400 transition-colors hover:bg-red-50 hover:text-red-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-200/80"
        aria-label={isUploading ? "Cancel upload" : "Remove file"}
      >
        <X className="h-4 w-4" strokeWidth={2.25} aria-hidden />
      </button>
    </div>
  );
};

/** Use on `Upload` to keep list items compact; pairs with `itemRender`. */
export const separationDocumentUploadListClassName =
  "[&_.ant-upload-list-item-container]:!block [&_.ant-upload-list]:mt-1.5 [&_.ant-upload-list-item]:!mt-0";

/** Use on `Upload` to align the file list side-by-side with the button. */
export const separationDocumentUploadSideBySideClassName =
  "!flex flex-wrap items-center gap-x-4 gap-y-2 [&_.ant-upload]:!inline-block [&_.ant-upload-list]:!inline-block [&_.ant-upload-list]:!mt-0 [&_.ant-upload-list-item-container]:!block [&_.ant-upload-list-item]:!mt-0";
